import React, { Component } from "react";
import {
  ReactiveBase,
  ReactiveList,
  SelectedFilters,
  DataSearch,
} from "@appbaseio/reactivesearch";
import Moment from "moment";
import Layout from "../components/layout";
import DeleteResource from "../components/deleteResource";
import Popup from "reactjs-popup";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

class UpdateResources extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Layout>
          <div
            class="row card-header pt-2 text-lg"
            style={{ paddingBottom: 20 + "px" }}
          >
            <span style={{ color: "black", paddingLeft: 10 + "px" }}>
              <a href="/">Home</a>/Resources
            </span>
          </div>
          <div class="row body_content">
            <div class="row mx-auto" style={{ width: 90 + "%" }}>
              <ReactiveBase
                app={process.env.REACT_APP_ELASTICSEARCH_APP}
                url={process.env.REACT_APP_ELASTICSEARCH_URL}
                headers={{
                  Authorization: `ApiKey ${process.env.REACT_APP_ELASTICSEARCH_API_KEY}`,
                }}
              >
                <div className="pt-4  col-span-1 col-filter">
                  <h2>Search by Text</h2>

                  <DataSearch
                    componentId="SearchSensor"
                    dataField={["toolName", "description"]}
                    highlight
                    customHighlight={() => ({
                      highlight: {
                        pre_tags: ["<mark>"],
                        post_tags: ["</mark>"],
                        fields: {
                          text: {},
                          toolName: {},
                          domain: {},
                          description: {},
                        },
                        number_of_fragments: 0,
                      },
                    })}
                    // title="Search by Text"
                    placeholder="Search Resources"
                    autosuggest={false}
                    highlight={true}
                    highlightField="type"
                    queryFormat="or"
                    fuzziness={0}
                    debounce={100}
                    queryFormat="and"
                    react={{
                      and: ["SearchFilter"],
                    }}
                    URLParams={true}
                    showFilter={true}
                    URLParams={false}
                    className="custom-class"
                    innerClass={{
                      title: "search-title",
                    }}
                  />
                </div>
                <SelectedFilters />
                <ReactiveList
                  componentId="SearchResult"
                  dataField="toolName"
                  pagination={true}
                  paginationAt="top"
                  sortOptions={[
                    {
                      label: "Sorted by Published Date",
                      dataField: "publishDate",
                      sortBy: "desc",
                    },
                  ]}
                  pages={6}
                  size={14}
                  scrollOnChange={false}
                  loader="Loading Results.."
                  showResultStats={true}
                  innerClass={{
                    sortOptions: "search-sort",
                    pagination: "pg-css",
                  }}
                  render={({ data }) => (
                    <Table class="table-fixed">
                      <Thead>
                        <Tr>
                          <Th
                            class="bg-blue-900 text-left ..."
                            style={{ width: "20%" }}
                          >
                            <span class=" pl-0 md:pl-4 text-black md:text-white">
                              Tool Name
                            </span>
                          </Th>
                          <Th
                            class="bg-blue-900 text-left  ..."
                            style={{ width: "20%" }}
                          >
                            <span class="pl-0 md:pl-4 text-black md:text-white">
                              Domain
                            </span>
                          </Th>
                          {/*   <th class="bg-gray-800 ..." style={{width:"20%"}}><span class="text-white">Links</span></th> */}
                          <Th
                            class="bg-blue-900 text-left ..."
                            style={{ width: "20%" }}
                          >
                            <span class="text-black  md:text-white">
                              Published Date
                            </span>
                          </Th>
                          <Th
                            class="bg-blue-900 text-left ..."
                            style={{ width: "20%" }}
                          >
                            <span class="text-black hidden md:text-white">
                              Action
                            </span>
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {data.map((res) => (
                          <Tr key={res._id}>
                            <Td>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: res.toolName,
                                }}
                                style={{ margin: 10 }}
                              />
                            </Td>
                            <Td> {res.domain}</Td>

                            <Td class="text-center">
                              {Moment(res.publishDate).format("MMMM DD YYYY")}
                            </Td>

                            <Td class="text-center">
                              <a href={"/edit?id=" + res._id}>
                                <button class="bg-blue-900 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded mr-4">
                                  Edit
                                </button>
                              </a>

                              <Popup
                                trigger={
                                  <button
                                    className="button mr-2 bg-red-700 hover:bg-red-500 text-white text-md my-2 py-2 px-2 rounded font-bold"
                                    aria-haspopup="true" // Indicates this button triggers a modal
                                    aria-controls="modal-delete-resource" // References the modal by ID
                                  >
                                    Delete
                                  </button>
                                }
                                modal
                                nested
                              >
                                {(close) => (
                                  <div
                                    id="modal-delete-resource" // Modal ID for accessibility reference
                                    className="modal nested"
                                    role="dialog"
                                    aria-labelledby="modal-header" // References the modal header
                                    aria-describedby="modal-content" // References the modal content
                                  >
                                    <button
                                      className="close"
                                      onClick={close}
                                      aria-label="Close modal"
                                    >
                                      &times;
                                    </button>
                                    <div id="modal-header" className="header">
                                      Delete NADRC Resource
                                    </div>
                                    <div id="modal-content" className="content">
                                      <DeleteResource
                                        indexName={process.env.REACT_APP_NAME}
                                        indexNameArchive={
                                          process.env.REACT_APP_NAME_ARCHIVE
                                        }
                                        ElasticID={res._id}
                                      />
                                    </div>
                                  </div>
                                )}
                              </Popup>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  )}
                  react={{
                    and: ["SearchSensor"],
                  }}
                />
              </ReactiveBase>

              <div class="post-content" style={{ width: 90 + "%" }}></div>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}
export default UpdateResources;
